import { render, staticRenderFns } from "./outDetail.vue?vue&type=template&id=400a6078&scoped=true"
import script from "./outDetail.vue?vue&type=script&lang=js"
export * from "./outDetail.vue?vue&type=script&lang=js"
import style0 from "./outDetail.vue?vue&type=style&index=0&id=400a6078&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400a6078",
  null
  
)

export default component.exports